import { render, staticRenderFns } from "./InfoItem.vue?vue&type=template&id=12e8451f&scoped=true"
import script from "./InfoItem.vue?vue&type=script&lang=js"
export * from "./InfoItem.vue?vue&type=script&lang=js"
import style0 from "./InfoItem.vue?vue&type=style&index=0&id=12e8451f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e8451f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e8451f')) {
      api.createRecord('12e8451f', component.options)
    } else {
      api.reload('12e8451f', component.options)
    }
    module.hot.accept("./InfoItem.vue?vue&type=template&id=12e8451f&scoped=true", function () {
      api.rerender('12e8451f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Store/InfoItem.vue"
export default component.exports